import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "snooze-dialog-content"
};
const _hoisted_2 = {
  class: "btn-group"
};
const _hoisted_3 = {
  class: "btn-group"
};
import { ref, reactive, watch, toRaw } from 'vue';
import { ElMessage } from 'element-plus';
import { mctRequest } from '@/api/axios';
import { differenceInMinutes } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import DialogHeader from '@/components/dialog-header/index.vue';
import { storeToRefs } from 'pinia';
import { useUserDefaultSettingStore } from '@/store/user';
import { useSnoozeStore } from '@/store/snooze';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const store = useUserDefaultSettingStore();
    const {
      timeZone,
      timeZoneArea,
      userCEC
    } = storeToRefs(store);
    const snoozeStore = useSnoozeStore();
    const {
      clusterId,
      isShowSnoozeDialog
    } = storeToRefs(snoozeStore);
    // do not use same name with ref
    const snoozeForm = reactive({
      id: 0,
      name: '',
      status: 1,
      time: '',
      isTicketDone: true,
      memo: '',
      ticketnum: ''
    });
    const snoozeFormRef = ref();
    const rules = reactive({
      memo: [{
        required: true,
        message: 'Please input the description',
        trigger: 'blur'
      }],
      ticketnum: [{
        required: true,
        message: 'Please input the ticket number',
        trigger: 'blur'
      }]
    });
    const autoRecoverRadio = ref(2);
    const autoRecoverTime = ref('');
    const autoRecoverDuration = ref();
    const autoRecoverDurationOptions = [{
      value: '30',
      label: '0.5 hour'
    }, {
      value: '60',
      label: '1 hour'
    }, {
      value: '120',
      label: '2 hour'
    }, {
      value: '180',
      label: '3 hour'
    }, {
      value: '240',
      label: '4 hour'
    }, {
      value: '300',
      label: '5 hour'
    }, {
      value: '360',
      label: '6 hour'
    }, {
      value: '1440',
      label: '1 day'
    }, {
      value: '2880',
      label: '2 days'
    }, {
      value: '4320',
      label: '3 days'
    }, {
      value: '999999',
      label: 'Never'
    }];
    const getSnoozeCluster = async () => {
      const config = {
        url: `/clusters/id/${clusterId.value}/simplecluster`
      };
      const {
        simpleCluster
      } = await mctRequest.request(config);
      snoozeForm.id = simpleCluster.id;
      snoozeForm.name = simpleCluster.name;
      snoozeForm.time = simpleCluster.time || formatInTimeZone(new Date(), timeZoneArea.value, 'yyyy-MM-dd HH:mm:ss');
    };
    const validateFormBeforeSnooze = async () => {
      if (!snoozeFormRef.value) return;
      await snoozeFormRef.value.validate(valid => {
        if (valid) {
          handleSnooze();
        }
      });
    };
    const handleSnooze = async () => {
      const duration = autoRecoverRadio.value === 1 ?
      // @ts-ignore
      differenceInMinutes(new Date(autoRecoverTime.value), new Date(snoozeForm.time)) : autoRecoverDuration.value || 1440;
      const config = {
        url: `/snooze/update/int/${timeZone.value}`,
        method: 'post',
        data: {
          CommonSnoozeList: [{
            // forceSnooze is 1 when snoozing cluster
            forceSnooze: 1,
            id: snoozeForm.id,
            memo: snoozeForm.memo,
            recover: duration,
            // status is 1 when snoozing cluster
            status: 1,
            ticketnum: snoozeForm.ticketnum,
            time: snoozeForm.time,
            // type is 0 when snoozing cluster
            type: 0,
            username: userCEC.value
          }]
        }
      };
      await mctRequest.request(config);
      ElMessage({
        type: 'success',
        message: 'Snooze Successfully'
      });
      init();
    };
    const unSnoozeClusterTableData = ref([]);
    const getUnSnoozeCluster = async () => {
      const config = {
        url: `/snooze/query/${clusterId.value}`
      };
      const {
        commonSnoozes
      } = await mctRequest.request(config);
      unSnoozeClusterTableData.value = commonSnoozes;
    };
    const selectedRows = ref([]);
    const handleSelectionChange = selection => {
      selectedRows.value = selection;
    };
    const handleUnSnooze = async () => {
      if (!selectedRows.value?.length) {
        ElMessage({
          type: 'warning',
          message: 'Please select at least one row'
        });
        return;
      }
      const selection = toRaw(selectedRows.value).map(item => {
        item.status = 0;
        item.username = userCEC.value;
        return toRaw(item);
      });
      const config = {
        url: `/snooze/update/int/${timeZone.value}`,
        method: 'post',
        data: {
          CommonSnoozeList: selection,
          onlyRecover: true
        }
      };
      await mctRequest.request(config);
      ElMessage({
        type: 'success',
        message: 'UnSnooze Successfully'
      });
      init();
    };
    const init = () => {
      getSnoozeCluster();
      getUnSnoozeCluster();
    };
    watch(() => isShowSnoozeDialog.value, () => {
      if (isShowSnoozeDialog.value) {
        init();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(isShowSnoozeDialog),
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _isRef(isShowSnoozeDialog) ? isShowSnoozeDialog.value = $event : null),
        "show-close": false,
        width: "80%"
      }, {
        header: _withCtx(({
          close
        }) => [_createVNode(DialogHeader, {
          onClose: close,
          "header-name": "Snooze/UnSnooze",
          "guide-link": "aaa"
        }, null, 8, ["onClose"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[17] || (_cache[17] = _createElementVNode("h2", {
          class: "snooze-title"
        }, "Snooze Cluster", -1)), _createVNode(_component_el_form, {
          class: "snooze-form",
          ref_key: "snoozeFormRef",
          ref: snoozeFormRef,
          model: snoozeForm,
          rules: rules,
          "label-position": "top",
          "label-width": "150px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "Name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: snoozeForm.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => snoozeForm.name = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "Recover Condition"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_checkbox, {
              modelValue: snoozeForm.isTicketDone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => snoozeForm.isTicketDone = $event),
              disabled: ""
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode(" Ticket done ")])),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "Auto Recover"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: autoRecoverRadio.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => autoRecoverRadio.value = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                value: 1
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  placeholder: "Select Date and Time",
                  modelValue: autoRecoverTime.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => autoRecoverTime.value = $event),
                  type: "datetime"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_radio, {
                value: 2
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: autoRecoverDuration.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => autoRecoverDuration.value = $event),
                  class: "m-2",
                  placeholder: "1 Day"
                }, {
                  default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(autoRecoverDurationOptions, item => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]);
                  }), 64))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "memo",
            label: "Description"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: snoozeForm.memo,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => snoozeForm.memo = $event),
              class: "table-input",
              placeholder: "Memo"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "ticketnum",
            label: "Ticket Number"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: snoozeForm.ticketnum,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => snoozeForm.ticketnum = $event),
              class: "table-input",
              placeholder: "Ticket"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = $event => isShowSnoozeDialog.value = false)
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("Cancel")])),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: validateFormBeforeSnooze,
          type: "success"
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode(" Submit ")])),
          _: 1
        })]), _cache[18] || (_cache[18] = _createElementVNode("h2", {
          class: "snooze-title"
        }, "UnSnooze Cluster", -1)), _createVNode(_component_el_table, {
          data: unSnoozeClusterTableData.value,
          border: "",
          style: {
            "width": "100%"
          },
          "row-key": "id",
          onSelectionChange: handleSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "40"
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "Name",
            width: "180"
          }), _createVNode(_component_el_table_column, {
            prop: "snooze",
            label: "Snooze"
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [_createElementVNode("template", null, [_createElementVNode("div", null, "Snooze")], -1)])),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "",
            label: "Cluster"
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [_createElementVNode("template", null, [_createElementVNode("div", null, "Cluster")], -1)])),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "time",
            label: "Snooze Start Time",
            width: "180"
          }), _createVNode(_component_el_table_column, {
            prop: "recover",
            label: "Recover Duration",
            width: "180"
          }), _createVNode(_component_el_table_column, {
            prop: "forceSnooze",
            label: "Recover Condition",
            width: "180"
          }, {
            default: _withCtx(scope => [_createElementVNode("div", null, _toDisplayString(scope.row.forceSnooze === 1 ? 'ticket done' : scope.row.forceSnooze === 2 ? '5 polls pass' : ''), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "ticketStatus",
            label: "Status"
          }), _createVNode(_component_el_table_column, {
            prop: "username",
            label: "User"
          }), _createVNode(_component_el_table_column, {
            prop: "memo",
            label: "Reason"
          }), _createVNode(_component_el_table_column, {
            prop: "ticketnum",
            label: "Ticket Number",
            width: "180"
          })]),
          _: 1
        }, 8, ["data"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = $event => isShowSnoozeDialog.value = false)
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("Cancel")])),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: handleUnSnooze,
          type: "primary"
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("Un Snooze")])),
          _: 1
        })])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});